/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Share_Max_DownloadsInputs */

const cs_documents_share_max_downloads = /** @type {(inputs: Documents_Share_Max_DownloadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max. stažení`)
};

const en_documents_share_max_downloads = /** @type {(inputs: Documents_Share_Max_DownloadsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max downloads`)
};

/**
* | output |
* | --- |
* | "Max downloads" |
*
* @param {Documents_Share_Max_DownloadsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_share_max_downloads = /** @type {((inputs?: Documents_Share_Max_DownloadsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Share_Max_DownloadsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_share_max_downloads(inputs)
	return cs_documents_share_max_downloads(inputs)
});